// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileInputWithLinks_wrapper__px10M","registeredInput":"ProfileInputWithLinks_registeredInput__LZgdk","label":"ProfileInputWithLinks_label__Oxo0z"};